/*
Sample Usage:
events.publish('ga.page')
events.publish('ga.event', {category: 'thing', action: 'other-thing'})
*/

/*
Notes:
Single page apps: https://developers.google.com/analytics/devguides/collection/analyticsjs/single-page-applications
*/

import events from './events.js';

let GAHandler = (function() {

  return {
    handleEvent(data) {
      // Sample: ga('send', 'event', [eventCategory], [eventAction], [eventLabel], [eventValue], [fieldsObject]);
      // https://developers.google.com/analytics/devguides/collection/analyticsjs/events#implementation
      /* Details:
      eventCategory	text	yes	Typically the object that was interacted with (e.g. 'Video')
      eventAction	text	yes	The type of interaction (e.g. 'play')
      eventLabel	text	no	Useful for categorizing events (e.g. 'Fall Campaign')
      eventValue	integer	no	A numeric value associated with the event (e.g. 42)
      */
      try { // GA is best effort
        if (window.ga) {
          if (data.value) {
            window.ga('send', 'event', data.category, data.action, data.label, data.value);
          } else if (data.label) {
            window.ga('send', 'event', data.category, data.action, data.label);
          } else {
            window.ga('send', 'event', data.category, data.action);
          }
          console.info('ga.event', data);
        }
      } catch (e) {
        console.warn('Could not send event', e);
      }
    },

    handlePage(data) {
      // Sample: ga('send', 'pageview', [page], [fieldsObject]);
      // https://developers.google.com/analytics/devguides/collection/analyticsjs/pages#overview
      /* Details:
      title	text	no	The title of the page (e.g. homepage)
      location	text	no *	URL of the page being tracked.
      page	text	no *	The path portion of a URL. This value should start with a slash (/) character.
      */
      try { // GA is best effort
        if (window.ga) {
          if (data && data.location) {
            let page = data.location;

            window.ga('send', 'pageview', page);
          } else {
            window.ga('send', 'pageview');
          }

          console.log('GA: pageview');
        }
      } catch (e) {
        console.warn('Could not send page view', e);
      }
    },

    userSet(data) {
      try { // GA is best effort
        if (window.ga && data) {
          window.ga('set', {
            user: data.id,
            access: data.privileges.level,
          });
        }
      } catch (e) {
        console.warn('Could not send user info', e);
      }
    },
  };
})();

events.subscribe('ga.page', GAHandler.handlePage);
events.subscribe('ga.event', GAHandler.handleEvent);
events.subscribe('userset', GAHandler.userSet);

export default GAHandler;
